import {useIsFeatureFlagEnabled} from 'src/lib/experimentation/useIsFeatureFlagEnabled'
import {isDeviceAndroid} from 'src/lib/utils/platform'

const useRedirectToWeb = (): boolean => {
  const flagEnabled = useIsFeatureFlagEnabled('loan-application-handoff-to-web-on-android')
  return isDeviceAndroid() && flagEnabled
}

export default useRedirectToWeb
